import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';

import { ProductRoutingModule } from './product-routing.module';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { ProductListResolver } from './product-list/product-list.resolver';
import { ProductDetailResolver } from './product-detail/product-detail.resolver';
import { ProductListSearchResolver } from './product-list/product-list-search.resolver';
import { ProductSearchComponent } from './product-search/product-search.component';
import { ProductSaleComponent } from './product-sale/product-sale.component';

@NgModule({
  declarations: [
    ProductListComponent,
    ProductDetailComponent,
    ProductSearchComponent,
    ProductSaleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProductRoutingModule,
    SharedModule,
    TranslateModule
  ],
  providers: [TranslateService, ProductListResolver, ProductDetailResolver, ProductListSearchResolver]
})
export class ProductModule { }
